import { render, staticRenderFns } from "./Mis_Boletas.vue?vue&type=template&id=79bc0c27&scoped=true&"
import script from "./Mis_Boletas.vue?vue&type=script&lang=js&"
export * from "./Mis_Boletas.vue?vue&type=script&lang=js&"
import style0 from "./Mis_Boletas.vue?vue&type=style&index=0&id=79bc0c27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bc0c27",
  null
  
)

export default component.exports